/* eslint-disable lines-around-directive */
(function IIFE() {
    // eslint-disable-next-line strict
    'use strict';

    function WidgetPlaylistController(Translation, Widget) {
        'ngInject';

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const vm = this;

        /**
         * Set parent controller.
         *
         * @param {Object} parentCtrl The parent controller object.
         */
        this.setParentController = function setParentController(parentCtrl) {
            vm.parentCtrl = parentCtrl;
        };

        /**
         * Get widget classes.
         *
         * @return {Array} An array of widget css classes.
         */
        function getWidgetClass() {
            const widgetClass = [];

            vm.parentCtrl.getWidgetClass(widgetClass);

            if (vm.widget.properties.viewModeVariant === 'ungrouped') {
                widgetClass.push('widget--view-mode-variant-ungroup');
            }

            return widgetClass;
        }

        /**
         * The widget is empty when there is no playlist configured for the current language.
         * Handles the multi-language structure with multiple IDs:
         * { playlist: { en: { ids: ['abc', 'def'] }, fr: { ids: ['xyz'] } } }
         *
         * Also handles legacy format:
         * 1. Single playlist: { playlist: { id: 'abc' } }
         */
        function isEmpty() {
            const inputLanguage = Translation.inputLanguage;
            const playlist = vm.widget.properties?.playlist;
            const isInDesigner = vm.parentCtrl?.designerMode();

            // Get playlist data for current language using the translate method to get the language hierarchy
            const translatedPlaylist = isInDesigner ? playlist?.[inputLanguage] : Translation.translate(playlist);

            // Check for new multi-language structure with ids array
            if (translatedPlaylist?.ids && Array.isArray(translatedPlaylist.ids) && translatedPlaylist.ids.length > 0) {
                return false;
            }

            if (playlist && playlist?.id) {
                return false;
            }

            return true;
        }

        /**
         * Function that conditions the rendering of the widget content.
         *
         * @see widget-playlist.html
         */
        function isWidgetEmpty() {
            return isEmpty();
        }

        /**
         * In designer mode, when the widget is empty, it is visible and displays the widget type `PLAYLIST - LUMAPPS PLAY`
         *
         * In reader mode, when the widget is empty, it is not displayed at all
         *
         * @see widget-playlist.html
         */
        function isWidgetHidden() {
            return !vm.parentCtrl.designerMode() && isEmpty();
        }

        /**
         * Update widget properties.
         * Used by the auto-migration hook to persist legacy format migrations.
         * Updates both the directive's scoped widget and the Widget service's current widget
         * to ensure the settings panel sees the changes.
         *
         * @param {Object} updatedProperties The updated properties.
         */
        function onChange(updatedProperties) {
            const mergedProperties = { ...vm.widget.properties, ...updatedProperties };

            // Update the directive's scoped widget
            vm.widget.properties = mergedProperties;

            // Update the Widget service's current widget (for settings panel)
            const currentWidget = Widget.getCurrent();
            if (currentWidget && currentWidget.uuid === vm.widget.uuid) {
                currentWidget.properties = mergedProperties;
            }
        }

        vm.getWidgetClass = getWidgetClass;
        vm.isWidgetEmpty = isWidgetEmpty;
        vm.isWidgetHidden = isWidgetHidden;
        vm.onChange = onChange;
    }

    function widgetPlaylistDirective() {
        'ngInject';

        function link(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: WidgetPlaylistController,
            controllerAs: 'vm',
            replace: true,
            require: ['widgetPlaylist', '^widget'],
            restrict: 'E',
            link,
            scope: {
                widget: '=',
            },
            templateUrl:
                '/client/front-office/modules/content/modules/widget/modules/widget-playlist/views/widget-playlist.html',
        };
    }

    window.angular.module('Widgets').directive('widgetPlaylist', widgetPlaylistDirective);
})();
